import { ROUTES } from '@/shared/constants/routes'
import { cn } from '@/lib/utils'
import { ReactNode } from 'react'
import { useIonRouter } from '@ionic/react'
import { AppNavbar } from '@/shared/ui/AppNavbar'

interface TimerTopBarProps {
	center: ReactNode
	className?: string
	centerClassName?: string
}

export const TimerTopBar = ({ center, className, centerClassName }: TimerTopBarProps) => {
	const nav = useIonRouter()

	return (
		<AppNavbar
			logoAriaLabel='Открыть главный экран'
			logoTap={{ enabled: false }}
			onLogoClick={() => {
				nav.push(ROUTES.overall.main)
				return true
			}}
			avatarVariant='plain'
			centerSlot={center}
			centerSlotClassName={cn('pointer-events-auto', centerClassName)}
			centerSlotStyle={{
				left: '50%',
				right: 'auto',
				width: 'min(380px, calc(100% - 184px))',
				transform: 'translateX(-50%)',
			}}
			className={cn(className)}
		/>
	)
}
